import { useEffect, useState } from 'react';

export default function useHidingHeader() {
  const [position, setPosition] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      let moving = window.pageYOffset;
      let visible = position > moving;

      setPosition(moving);

      if (document.documentElement.scrollTop < 100) {
        visible = true;
      }
      setVisible(visible);

    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return {
    transform: visible ? undefined : `translate(0, -100px)`,
    transition: 'transform 0.4s ease-out',
  };
}
